import { App } from "@linkfluence/models/app";

const LfProducts = [App.Radarly, App.Search, App.Tribes];
export const MwProducts = [App.Klear, App.MediaRelations];
export const BaseProducts = [App.Search];

export type Product = typeof LfProducts[number];
export type BaseProduct = typeof BaseProducts[number];

export const getLFProducts = () => LfProducts;
